import React, { useState } from 'react';
import BusMascot from '../components/BusMascot';

/**
 * ABC School - CDL Training Program Management
 * Tracks student enrollment, progress, scheduling, and certification
 */
const ABCSchool = () => {
  const [activeTab, setActiveTab] = useState('students');
  const [students] = useState([
    // Placeholder data - will be connected to backend
  ]);
  const [classes] = useState([]);

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="header-title">
          <BusMascot size={48} />
          <div>
            <h1>ABC School CDL Training</h1>
            <p className="subtitle">Commercial Driver's License Training Program</p>
          </div>
        </div>
        <button className="btn-primary">+ Enroll Student</button>
      </div>

      {/* Stats Overview */}
      <div className="stats-row">
        <div className="stat-box">
          <span className="stat-number">0</span>
          <span className="stat-label">Active Students</span>
        </div>
        <div className="stat-box">
          <span className="stat-number">0</span>
          <span className="stat-label">Classes This Week</span>
        </div>
        <div className="stat-box">
          <span className="stat-number">0</span>
          <span className="stat-label">Upcoming Tests</span>
        </div>
        <div className="stat-box">
          <span className="stat-number">0</span>
          <span className="stat-label">Certifications Issued</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs">
        <button 
          className={activeTab === 'students' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('students')}
        >
          Students
        </button>
        <button 
          className={activeTab === 'classes' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('classes')}
        >
          Classes
        </button>
        <button 
          className={activeTab === 'schedule' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('schedule')}
        >
          Schedule
        </button>
        <button 
          className={activeTab === 'certifications' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('certifications')}
        >
          Certifications
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'students' && (
          <div className="students-section">
            {students.length === 0 ? (
              <div className="empty-state">
                <BusMascot size={100} />
                <h3>No Students Enrolled</h3>
                <p>Enroll your first CDL training student to get started.</p>
                <button className="btn-primary">+ Enroll Student</button>
              </div>
            ) : (
              <div className="table-container">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Program</th>
                      <th>Start Date</th>
                      <th>Progress</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {students.map(student => (
                      <tr key={student.id}>
                        <td>{student.name}</td>
                        <td>{student.program}</td>
                        <td>{student.start_date}</td>
                        <td>
                          <div className="progress-bar">
                            <div 
                              className="progress-fill" 
                              style={{ width: `${student.progress}%` }}
                            />
                          </div>
                        </td>
                        <td>{student.status}</td>
                        <td>
                          <button className="btn-small">View</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {activeTab === 'classes' && (
          <div className="classes-section">
            {classes.length === 0 ? (
              <div className="empty-state">
                <h3>No Classes Scheduled</h3>
                <p>Create your first class to begin training.</p>
                <button className="btn-primary">+ Create Class</button>
              </div>
            ) : (
              <div className="classes-grid">
                {classes.map(cls => (
                  <div key={cls.id} className="class-card">
                    <h3>{cls.name}</h3>
                    <p>{cls.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'schedule' && (
          <div className="schedule-section">
            <div className="empty-state">
              <h3>Training Schedule</h3>
              <p>Schedule view coming soon. Use the Calendar page for now.</p>
            </div>
          </div>
        )}

        {activeTab === 'certifications' && (
          <div className="certifications-section">
            <div className="empty-state">
              <h3>Certifications Issued</h3>
              <p>Track CDL certifications issued through the program.</p>
            </div>
          </div>
        )}
      </div>

      {/* Program Info */}
      <div className="program-info">
        <h2>CDL Training Programs</h2>
        <div className="programs-grid">
          <div className="program-card">
            <h3>Class B CDL</h3>
            <p>School bus endorsement training</p>
            <ul>
              <li>40 hours classroom</li>
              <li>20 hours behind-the-wheel</li>
              <li>DMV test preparation</li>
            </ul>
          </div>
          <div className="program-card">
            <h3>Passenger Endorsement</h3>
            <p>Required for school bus drivers</p>
            <ul>
              <li>Safety procedures</li>
              <li>Student management</li>
              <li>Emergency protocols</li>
            </ul>
          </div>
          <div className="program-card">
            <h3>Refresher Course</h3>
            <p>Annual certification renewal</p>
            <ul>
              <li>8 hours classroom</li>
              <li>Skills assessment</li>
              <li>Updated regulations</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ABCSchool;
